<template>
  <!--콘텐츠 영역-->
  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>

    <div class="item">
      <div class="tit"><h3>LOGO TYPE</h3></div>

      <ul class="CI_frame">
        <li class="CI_img-01">
          <img :src="require('./../../assets/img/sub/01/0105_01.png')" />
        </li>
        <li>
          <p class="CI_txt">
            FERRUM INFRA는 골프장 사업부터 MRO사업에 이르기까지 다양한 사업을 수행하는 인프라 회사로 ‘i’와 ‘a’를 이음으로 동국제강 그룹의 모든 인프라 활동을 지원하며 그룹 성장동력의 안전한 초석을 제공한다는 의미를 담고 있다.<br />
            로고타입은 모던한 서체를 사용하여 정직하고 건실한 기업임을 나타내고
            있으며 Red Color는 열정과 단결을 상징한다.
          </p>
        </li>
        <li class="pdt50">
          <p class="CI_txt">
            워드마크는 모든 매체에 일관되게 적용되어 기업의 이미지를 전달하는
            중요한 역할을 한다. 따라서 최대한 워드마크의 형태와 색상을 유지하여
            사용하도록 해야한다.<br />
            최소 크기 규정은 영문 워드마크의 가독성을 고려하여 정한것으로 최소
            이하의 사용은 금한다.
          </p>
        </li>
      </ul>
    </div>

    <div class="item">
      <div class="tit"><h3>COlOR SYSTEM</h3></div>

      <ul class="CI_frame">
        <li style="padding-bottom: 80px;">
          <p class="CI_txt">
            Ferrum Infra의 전용 색상은 워드마크의 성격을 대표하는 기본체계 중
            하나로서 모든 매체에 동일하게 표현되어야 하며, 정확한 색상과 명도,
            체도 등을 일정하게 유지하여 사용한다. <br />
            사인물 등에 적용될 경우 재질이나 조명 여건 등을 검토하여 최적의
            색상을 유지하여야 하며, 작업 과정에서 정확한 색상을 유지하여야 하며,
            작업 과정에서 정확한 색상의 제현을 위해서는 아래 제시한 규정에 따라
            활용한다.
          </p>
        </li>
        <li class="ci_color">
          <div class="color_bar red">
            <p>FERRUM RED<span>PANTONE 1805C</span></p>
          </div>
          <div class="CI_frame_table">
            <table>
              <tbody>
                <tr>
                  <th>CMYK</th>
                  <td>C0</td>
                  <td>M100</td>
                  <td>Y80</td>
                  <td>K35</td>
                </tr>
                <tr>
                  <th>RGB</th>
                  <td>R164</td>
                  <td>G0</td>
                  <td>B18</td>
                  <td></td>
                </tr>
                <tr>
                  <th>LG</th>
                  <td colspan="4">LT4011A</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li class="ci_color">
          <div class="color_bar">
            <p>FERRUM DARK BROWN<span>PANTONE 411C</span></p>
          </div>
          <div class="CI_frame_table">
            <table>
              <tbody>
                <tr>
                  <th>CMYK</th>
                  <td>C75</td>
                  <td>M68</td>
                  <td>Y100</td>
                  <td>K10</td>
                </tr>
                <tr>
                  <th>RGB</th>
                  <td>R58</td>
                  <td>G48</td>
                  <td>B12</td>
                  <td></td>
                </tr>
                <tr>
                  <th>LG</th>
                  <td colspan="4">LT4011A</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "CiTab.vue"
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub01/CiTab.vue